<!--<pre style="background-color: pink">
  hasSlides: {{ hasSlides() }}
  shouldShowStatic: {{ shouldShowStatic() }}
  shouldShowCarousel: {{ shouldShowCarousel() }}
</pre> -->
@if(hasSlides()) {
<section
  class="hero-carousel"
  role="banner"
  aria-label="Ofertas destacadas"
  itemscope
  itemtype="https://schema.org/ItemList"
  [attr.data-carousel-ready]="shouldShowCarousel()"
  [attr.data-hydrated]="isHydrated()"
>
  <!-- ✅ CONTENIDO ESTÁTICO PARA SSR + LCP -->
  @if(shouldShowStatic()) {
  <article
    class="hero-carousel__static-slide"
    itemscope
    itemtype="https://schema.org/Product"
    itemProp="itemListElement"
  >
    <a
      [href]="firstSlide().url"
      (click)="onClickBanner($event, 0)"
      class="hero-carousel__link"
      [attr.aria-label]="'Ver oferta: ' + firstSlide().alt"
      itemProp="url"
    >
      <figure class="hero-carousel__figure">
        <img
          [ngSrc]="getCurrentSlideImage(firstSlide()!)"
          [alt]="firstSlide().alt"
          fill
          sizes="100vw"
          priority
          loading="eager"
          fetchpriority="high"
          decoding="sync"
          class="hero-carousel__image hero-carousel__image--critical"
          itemProp="image"
        />

        @if(firstSlide().title) {
        <figcaption class="sr-only" itemProp="name">
          {{ firstSlide().title }}
        </figcaption>
        }
      </figure>
    </a>
  </article>
  }

  <!-- ✅ CAROUSEL INTERACTIVO (Progressive Enhancement) -->
  @if(shouldShowCarousel()) {
  <div class="hero-carousel__interactive">
    <p-carousel
      [value]="slides()"
      [numVisible]="1"
      [numScroll]="1"
      [autoplayInterval]="8000"
      [circular]="true"
      [showIndicators]="true"
      [showNavigators]="true"
      role="region"
      aria-label="Carrusel de productos destacados"
    >
      <ng-template let-i="index" let-slide pTemplate="item">
        <article
          class="hero-carousel__slide"
          itemscope
          itemtype="https://schema.org/Product"
          [attr.itemprop]="'itemListElement'"
          [attr.data-position]="i + 1"
        >
          <a
            [href]="slide.buttonUrl"
            (click)="onClickBanner($event, i)"
            class="hero-carousel__link"
            [attr.aria-label]="'Ver oferta: ' + slide.alt"
            itemProp="url"
          >
            <figure class="hero-carousel__figure">
              <img
                [ngSrc]="getCurrentSlideImage(slide)"
                [alt]="slide.alt"
                fill
                sizes="100vw"
                [attr.priority]="i === 0 ? '' : null"
                [loading]="i <= 1 ? 'eager' : 'lazy'"
                [attr.fetchpriority]="i === 0 ? 'high' : 'auto'"
                [attr.decoding]="i === 0 ? 'sync' : 'async'"
                class="hero-carousel__image"
                [class.hero-carousel__image--priority]="i === 0"
                itemProp="image"
              />

              @if(slide.title) {
              <figcaption class="sr-only" itemProp="name">
                {{ slide.title }}
              </figcaption>
              }
            </figure>
          </a>
        </article>
      </ng-template>
    </p-carousel>
  </div>
  }

  <!-- ✅ STRUCTURED DATA CRÍTICO PARA SEO -->
  <script
    type="application/ld+json"
    [innerHTML]="getStructuredData()"
  ></script>
</section>
} @else if(isLoading()) {
<!-- ✅ SKELETON MIENTRAS CARGA (solo si está cargando) -->
<section class="hero-carousel" role="banner" aria-label="Cargando ofertas">
  <div class="hero-carousel__skeleton">
    <p-skeleton
      styleClass="hero-carousel__skeleton-item"
      animation="wave"
      borderRadius="0"
    />

    <!-- Skeleton de indicadores -->
    <div class="hero-carousel__skeleton-indicators">
      @for(item of [1, 2, 3, 4, 5]; track $index) {
      <p-skeleton width="32px" height="8px" borderRadius="0" />
      }
    </div>
  </div>
</section>
} @else {
<!-- ✅ FALLBACK SI NO HAY SLIDES Y NO ESTÁ CARGANDO -->
<section
  class="hero-carousel hero-carousel--empty"
  role="banner"
  aria-label="No hay ofertas disponibles"
>
  <div class="hero-carousel__empty-state">
    <p class="sr-only">No hay ofertas disponibles en este momento</p>
  </div>
</section>
}
